import { render, staticRenderFns } from "./whiteLineAttr.vue?vue&type=template&id=18c068a4&scoped=true"
import script from "./whiteLineAttr.vue?vue&type=script&lang=js"
export * from "./whiteLineAttr.vue?vue&type=script&lang=js"
import style0 from "./whiteLineAttr.vue?vue&type=style&index=0&id=18c068a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c068a4",
  null
  
)

component.options.__file = "whiteLineAttr.vue"
export default component.exports